<template>
  <div class="jsycDetail">
    <ld-header
      @click-left="back"
      transparent
      white
      :z-index="99999"
    >
      <img
        slot="left"
        class="custom-back"
        src="~Assets/images/back.png"
      >
    </ld-header>
    <detail
      ref="detail"
      :order-id="this.id"
    />
  </div>
</template>

<script>
import detail from '../carQuery/carDriving'

export default {
  name: 'JsycDetail',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    detail
  },
  mounted () {
    this.$refs.detail.toggle({
      id: this.id,
      show: true
    })
  },
  methods: {
    back () {
      this.$refs.detail.clearTimer(true)
      this.$router.push({ path: '/allOrder?findType=1' })
    }
  }
}
</script>

<style>

</style>
